import { render, staticRenderFns } from "./add-heir.vue?vue&type=template&id=49ba4058&"
import script from "./add-heir.vue?vue&type=script&lang=js&"
export * from "./add-heir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports